<template>
  <div class="home-wrapper">
    <div id="carouselExampleControls" class="carousel slide carousel-fade" data-ride="carousel">
      <div class="carousel-inner">
        <div
          v-for="(slide, index) in slides"
          :key="slide"
          class="carousel-item"
          :class="{active:index==0}"
          data-interval="20000"
        >
          <span
            :style="{'background-image':'url('+slide+')'}"
            class="slideshow"
          >{{ 'slide'+index.toString() }}</span>
        </div>
      </div>
      <a
        class="carousel-control-prev"
        href="#carouselExampleControls"
        role="button"
        data-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true" />
        <span class="sr-only">Previous</span>
      </a>
      <a
        class="carousel-control-next"
        href="#carouselExampleControls"
        role="button"
        data-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true" />
        <span class="sr-only">Next</span>
      </a>
    </div>
    <div class="wel-band">
      <div class="jumbotron text-center py-5">
        <h1 class="display-4 mb-4">Welcome to Rmdyh's Blog!</h1>
        <p class="lead">我的个人主页，用于记录日常学习到的一些小技巧和知识，比起技术博客更像是备忘录合集</p>
        <hr class="my-4" />
        <p class="subp">
          This website is used to archive some skills and knowledge I learn in my daily study.
          <br />Compared to some tech-blogs, it looks more like a collection of notes.
        </p>
        <!--p class="subp">
          如果您是我的熟人，也可以通过输入四位密码（你一定知道是什么 :-P）
          <span class="font-weight-bold">解锁</span>查看更多内容
          <br />If you are my acquaintance, you can also
          <span class="font-weight-bold">unlock</span>
          it at the navbar by entering a four-digit password (you must know what it is :-P) to see more content.
        </p-->
      </div>
    </div>
    <div class="container mt-5">
      <h2 class="text-center">Latest Posts</h2>
    </div>
    <div class="container pb-5">
      <timeline :posts="posts" />
      <div class="text-center">
        <a class="more" href="#" style="color:inherit">
          See more posts
          <svg class="icon ml-2" aria-hidden="true">
            <use xlink:href="#icon-rightarrowcircle" />
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import timeline from '@/components/timeline'
import posts from '@/assets/posts/postlist.js'
import '@/assets/js/rightarrowcircle.js'

function urlAll (r) {
  return r.keys().map(key => r(key))
}

export default {
  data: () => ({
    slides: urlAll(require.context('@/assets/images/slides', false, /\.jp?g$/)),
    posts
  }),
  components: { timeline }
}
</script>

<style lang='scss'>
.home-wrapper {
  padding-bottom: 40px;
}

.slideshow {
  display: block;
  width: 100%;
  padding: 15% 0;
  background-size: cover;
  background-position: 50%;
  color: transparent;
}

.wel-band {
  .jumbotron {
    background-color: gray("200");
    border-radius: 0;
    .subp {
      max-width: 700px;
      margin-left: auto;
      margin-right: auto;
    }
  }
}

@media (min-width: 992px) {
  .wel-band {
    position: relative;
    margin: -8% auto 0;
    max-width: 950px;
    z-index: 2;
    .jumbotron {
      background-color: #fff;
      border-radius: 0.5rem;
    }
  }
}

.more {
  font-size: 20px;
  font-weight: 800;
  .icon {
    width: 1.5rem;
    height: 1.5rem;
    @include vertical-align-with-text;
  }
}
</style>
